import { MediaFileService } from './../../../../shared/services/media-file.service';
import { ToastrService } from 'ngx-toastr';
import { IMediaFile } from '../../../../_models/cms/IMediaFile';
import { IPaged } from '../../../../_models/common/IPaged';
import { HttpEventType, HttpEvent } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-media-file-list',
  templateUrl: './media-file-list.component.html'
})
export class MediaFileListComponent implements OnInit {
  barWidth: number = 0;
  isProgress: boolean = false;

  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Descending'
  };

  columns = [
    { title: 'Id', key: 'Id', isSortable: true },
    { title: 'Title', key: 'Title', isSortable: true },
    { title: 'MediaUrl', key: 'MediaUrl', isSortable: true },
    { },
    { }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private service: MediaFileService) { }

  ngOnInit() {
    this.route.queryParams
		.subscribe(params => {
			this.query.page = isNaN(params.page) ? 1 : params.page;
			this.query.sort = params.sort;
			this.query.sortDir = params.sortDir;
      this.populateMediaFiles();
    });

  }

  private populateMediaFiles() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if(response)
          this.queryResult = response;
      });

  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending"; 
    }

    this.router.navigate(['/admin/media-files'], { queryParams: this.query });
  }

  uploadFile(files: FileList) {
    this.service.authPostFile(files).subscribe(
      (event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress) {
              this.isProgress = true;
              this.barWidth = Math.round(event.loaded / event.total * 100);
          }
          else if (event.type === HttpEventType.Response) {
              this.isProgress = false;
              this.barWidth = 0;
              console.log(event);
              this.populateMediaFiles();
          }
    });
  }

  copy(url)
  {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
  
  delete(id: number) {
    if (!confirm('Are you sure you want to delete this media file?')) return;

    this.service.delete(id).subscribe(() => {
      this.toastrService.success('File deleted successful');
      this.populateMediaFiles();
    });
  }

}
